export default __webpack_public_path__ + "static/media/close.c9e6c820.svg";